import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './store/rootReducer';

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;

const preloadedState = {
  user: { userInfo: userInfoFromStorage }
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState,
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;